export { default } from "./capitalize.mjs";